import { Button as MuiButton, Paper as MuiPaper, styled, Theme, ToggleButton as MuiToggleButton } from "@mui/material";
import { blue } from "@mui/material/colors";

export const Paper = styled(MuiPaper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
  "& .MuiToggleButtonGroup-root": {
    gap: theme.spacing(0.5),
  },
}));

const buttonStyles = ({ theme }: { theme: Theme }) => ({
  color: theme.palette.biarri.secondary.darkGrey,
  border: "none",
  height: 28,
  width: 28,
  minWidth: 28,
  padding: 0,

  "& svg": {
    width: 20,
    height: 20,
  },

  "&&&": {
    borderRadius: `${theme.shape.borderRadius}px`,
  },

  "&&&.has-options": {
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  },

  "&.MuiButton-root:hover, &.MuiToggleButton-root:hover": {
    color: theme.palette.primary.main,
  },

  "&.MuiToggleButton-root.Mui-disabled": {
    border: "none",
  },

  "&&.Mui-selected, &&.Mui-selected.MuiButton-root:hover": {
    backgroundColor: blue[50],
    color: theme.palette.info.main,
  },

  // Full variant styling
  "&&&.variant-full": {
    width: "auto",
    minWidth: 185,
    height: "auto",
    padding: theme.spacing(0.5, 1),
    justifyContent: "flex-start",
  },
});

export const Button = styled(MuiButton)(buttonStyles);

export const ToggleButton = styled(MuiToggleButton)(buttonStyles);
